import { togglePropertyInfo } from "./propertyInfo";
import { toggleTriView } from "./triView";
import { useStore } from "../../stores/store";
import { DraggableKeys } from "../../interfaces/config";

export const executeToolbarActions = (wasActive: boolean, value: string) => {
  const {
    clearMap,
    deactivateTool,
    results,
    setResults,
    primaryLayer,
    highlightLayer,
    setSearchValue,
    setSelectedParcelItems,
  } = useStore.getState();

  const deactivatePropertyInfo = () => {
    deactivateTool("propertyInfo");
    togglePropertyInfo({ wasActive: true });
  };

  switch (value) {
    case "propertyInfo":
      togglePropertyInfo({ wasActive });
      break;
    case "clearMap":
      clearMap();
      setSearchValue("");
      setSelectedParcelItems([]);
      break;
    case "triView":
      toggleTriView({ wasActive });
      break;
    case DraggableKeys.MEASURE_DRAGGABLE:
      deactivatePropertyInfo();
      break;
    case DraggableKeys.MARKUP_DRAGGABLE:
      deactivatePropertyInfo();
      break;
    case "fullScreen":
      document.documentElement.requestFullscreen();
      break;
    case "clearSearch":
      primaryLayer &&
        primaryLayer
          .applyEdits({
            deleteFeatures: results,
          })
          .then(() => {
            setResults([]);
          });
      highlightLayer && highlightLayer.graphics.removeAll();
      break;
  }
};
